import { render } from "./WebsiteMain.vue?vue&type=template&id=1c7bffae&scoped=true"
import script from "./WebsiteMain.vue?vue&type=script&lang=js"
export * from "./WebsiteMain.vue?vue&type=script&lang=js"

import "./WebsiteMain.vue?vue&type=style&index=0&id=1c7bffae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7bffae"]])

export default __exports__